var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-stepper-form-section"},[_c('div',{class:{
      'dp-stepper-form-section__indicator': true,
      'dp-stepper-form-section__indicator--success': _vm.success,
    }},[_c('span',[_vm._v(_vm._s(_vm.sectionNumber))])]),_c('span',{staticClass:"dp-stepper-form-section__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }